export const wpHydration = 'data-wp-inline-image-hydration';
export const wpHydrationType = 'application/json';
export const moduleType = 'module';